import angular from 'angular';
import { attListThumbnailsComponent } from './attListThumbnailsComponent';
import 'components/sharpr/clickToDownload/clickToDownloadModule';
import 'components/sharpr/att/service/attServiceModule';

angular
	.module('sh.attListThumbnails', ['sh.clickToDownload', 'sh.attService'])
	.component('shAttListThumbnails', attListThumbnailsComponent());
